import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { main } = theme.palette.primary;

  return {
    tabBar: {
      maxWidth: 800,
      "& .mdc-tab": {
        fontFamily: "SuisseIntlRegular",
        color: "rgba(186, 186, 186, 1)",
        textTransform: "capitalize",
        padding: "0 16px",
        fontSize: 16,
        letterSpacing: "unset",
        height: 60,
        flex: "unset",
        minWidth: 90,
        maxWidth: 150,
        [theme.breakpoints.down("sm")]: {
          padding: "0 8px",
          minWidth: 60
        },
        [theme.breakpoints.down("xs")]: {
          height: 36,
          maxWidth: 120,
          padding: "0 16px"
        }
      },
      "& .mdc-tab__content": {
        [theme.breakpoints.up("sm")]: {
          alignItems: "flex-start",
          paddingTop: 26
        }
      },
      "& .mdc-tab--active .mdc-tab__text-label": {
        color: theme.palette.text.primary
      },
      "& .mdc-tab-indicator > .mdc-tab-indicator__content--underline ": {
        backgroundColor: main,
        height: 2
      },
      "& .mdc-tab__ripple::before, .mdc-tab__ripple::after": {
        backgroundColor: "transparent"
      }
    }
  };
});
